import axios from "axios";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "./EditCustProfile.scss";

interface IPROPS {
  customerData: any;
}

const EditCustProfile: React.FC<IPROPS> = ({ customerData }) => {
  const [name, setName] = useState(customerData?.data?.customer?.first_name || "");
  const [email, setEmail] = useState(customerData?.data?.customer?.email || "");
  const [phone, setPhone] = useState(customerData?.data?.customer?.phone || "");

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchingTenant = window.location.hostname.split(".")[0];
  const apiPort = process.env.REACT_APP_API_PROTOCOL;
  const token = localStorage.getItem("customer-token");

  // **Validation**
  const validateForm = () => {
    const newErrors = { name: "", email: "", phone: "" };

    // Name
    if (!name.trim()) {
      newErrors.name = "Name is required";
    } else if (name.trim().length < 2) {
      newErrors.name = "Name must be at least 2 characters";
    }

    // Email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Enter a valid email address";
    }

    // Phone
    const phoneRegex = /^[0-9]{10}$/;
    if (!phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!phoneRegex.test(phone)) {
      newErrors.phone = "Phone number must be 10 digits";
    }

    setErrors(newErrors);
    setIsFormValid(!newErrors.name && !newErrors.email && !newErrors.phone);
  };

  useEffect(() => {
    validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, email, phone]);

  // **Update Profile API**
  const updateHandler = async () => {
    if (!isFormValid) {
      toast.error("Please fill all fields correctly");
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.put(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/profile/`,
        {
          first_name: name,
          email,
          phone,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data) {
          toast.success("Profile updated successfully");
          window.location.href = '/customer/thank-you';
          

      }

      console.log("Profile updated:", response.data);
    } catch (error: any) {
      console.error("Error updating profile:", error);
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="edit-cust-profile">
      <div className="edit-cust-card">
        <h2>Edit Customer Profile</h2>

        {/* Name */}
        <div className="form-group">
          <label>
            Name <span>*</span>
          </label>
          <input
            type="text"
            placeholder="Enter your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className={errors.name ? "input-error" : ""}
          />
          {errors.name && <p className="error-msg">{errors.name}</p>}
        </div>

        {/* Email */}
        <div className="form-group">
          <label>
            Email <span>*</span>
          </label>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={errors.email ? "input-error" : ""}
          />
          {errors.email && <p className="error-msg">{errors.email}</p>}
        </div>

        {/* Phone */}
        <div className="form-group">
          <label>
            Phone <span>*</span>
          </label>
          <input
            type="tel"
            placeholder="Enter your phone number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className={errors.phone ? "input-error" : ""}
          />
          {errors.phone && <p className="error-msg">{errors.phone}</p>}
        </div>

        {/* Save Button */}
        <button
          className={`save-btn ${!isFormValid || isLoading ? "disabled" : ""}`}
          onClick={updateHandler}
          disabled={!isFormValid || isLoading}
        >
          {isLoading ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default EditCustProfile;
